import { Container, Button } from "react-bootstrap";

import "./index.scss";
import Banner from "../../../assets/images/black-boxes.jpg";
import GustoIcon from "../../../assets/images/gusto-icon.png";
import ConcentrixBanner from "../../../assets/images/concentrix-thank-you.jpg";
import Logo from "../../../assets/images/boxfox.png";
import { useBetween } from "use-between";
import useShopify from "../../../useShopify";
import WizBG from "../../../assets/images/wiz-bg.png";
import WizButton from "../../../components/wiz/wiz-button";
import WizBoxfoxLogo from "../../../assets/images/wiz-boxfox.png";
import WizTitle from "../../../components/wiz/wiz-title";
import PlentyBricks from "../../../assets/images/plenty-bricks.png";


const Complete = ({ next }) => {
  const { campaign } = useBetween(useShopify);

  const isEncore = campaign.companyId === "65cd150fdc2cf13513530120";
  const is1011 = campaign.companyId === "6530617ad257c395c2f9a961";
  const isWilmingtonTrust = campaign.companyId === "66bad2e5a6ecf67d94f0f31f";
  const isRegent =
    campaign.companyId === process.env.REACT_APP_REGENT_COMPANY_ID;
    const isConcentrix = campaign.companyId === "6792c702dca127a271574e4d";
    const isWiz = campaign.companyId === "67981cfbdca127a271575000";
    const isImpiricus = campaign.companyId === "66639212d7476d285f2b1cfe";
    const isCyera = campaign.companyId === "6840f57ecee86b5fec9562c6";
    const isNewGusto = campaign.companyId === "68c3332bcee86b5fec9588ab";
    const isCyeraSecretSanta2 = campaign.name === "CYERA SECRET SANTA GIFTS";
    const isPlenty = campaign.companyId === "696aaa2dcee86b5fec96369d";
    
  return (
    <div
      className={`brand-dashboard ${isEncore ? "encore-font" : "default-font"} ${isPlenty ? "plenty-mobile" : ""}`}
      style={
        isWilmingtonTrust ? { backgroundColor: "#fff" } :
        isWiz ? { backgroundImage: `url(${WizBG})`, backgroundSize: "cover", backgroundPosition: "left", minHeight: "100vh", height: "100%" } :
        isCyera ? { backgroundColor: "#BEB2FF" } :
        isNewGusto ? { backgroundColor: "#fff" } :
        isPlenty ? { backgroundColor: campaign.bgColor } :
        null
      }
    >
      <div className={`banner ${isWiz ? 'wiz-banner' : ''}`}>
        {isConcentrix ? (
          <img src={ConcentrixBanner} alt="banner" />
        ) : isWiz ? (
          campaign.loginImage.path ? (
            <img
              src={`${process.env.REACT_APP_API_URL}/${campaign.loginImage.path}`}
              alt="banner"
            />
          ) : null
        ) : isImpiricus ? (
          <img
                src={`${process.env.REACT_APP_API_URL}/${campaign.loginImage.path}`}
                alt="banner"
              />
        ) : isCyera ? (
          <img
                src={`${process.env.REACT_APP_API_URL}/${campaign.loginImage.path}`}
                alt="banner"
              />
        ) : isNewGusto ? (
          <div style={{position: "relative", height: "100%", width: "100%"}}>
            <img src={`${process.env.REACT_APP_API_URL}/${campaign.loginImage.path}`} alt="banner" />
            <img src={`${GustoIcon}`} alt="banner" style={{ width: "170px", height: "170px", display: "block", margin: "auto", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />
          </div>
        ) : isPlenty ? null : (
          <img src={Banner} alt="banner" />
        )}
      </div>
      <Container className="brand-actions" style={ isWiz ? { alignItems: "start" } : isImpiricus ? { backgroundColor: campaign.bgColor, color: "white" } : null }>
        <div className="logo">
          {isWiz ? (
            <img style={{ margin: 0, paddingLeft: "36px", maxWidth: "350px" }} src={WizBoxfoxLogo} alt="logo" />
          ) : isImpiricus || isCyera || isNewGusto || isPlenty ? (
            <img
                src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`}
                alt=""
              />
          ) : (
            <img src={Logo} alt="logo" />
          )}
        </div>
        <div className="company-logo">
          {isWiz ? (
            <WizTitle />
          ) : (
            campaign.logo.path ? (
              <img
                style={ isImpiricus || isCyera || isNewGusto || isPlenty ? { display: "none" } : null }
                src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`}
                alt=""
              />
            ) : null
          )}
        </div>
        {isConcentrix ? (
          <h4>
            Thank you!
          </h4>
        ) : isWiz ? (
          <p style={ isWiz ? { color: "#1e50e7", textAlign: "left" } : null } className="brand-desc">
          <>
          Thank you for submitting your selection, we can't wait to share the love! You will receive an email with tracking once your gift ships. <br></br>  If you have any questions or need to make any changes, please email our friends at {" "} <a href="mailto:concierge@boxfox.com">concierge@boxfox.com</a>
          </>
          </p>
        ) : (
          <p className="brand-desc">
            {isRegent ? (
              <>
              Your selections have been submitted and your apparel will be waiting for you onboard.
              <br />
              If you have any questions, please email{" "}
              <a href="mailto:concierge@shopboxfox.com">
                concierge@shopboxfox.com
              </a>
              .<br />
              Thank you!
            </>
          ) : isImpiricus ? (
            <>
              Thank you and enjoy!<br></br>
              RFP Survival kits will ship starting in June.
            </>
          ) : isCyeraSecretSanta2 ? (
            <>
              <b>Thank you!!</b><br></br>
              Your gift is on its way! Thank you for making your selection
            </>
          ): isCyera ? (
            <>
              <b>You're officially part of the Cyera Claus Exchange!</b><br></br>
              Our team is busy matching you with a colleague from around the world. Soon, you'll receive a portal link to choose the perfect surprise gift for them.<br></br>
              Get ready! Your holiday spirit is about to travel across borders!
            </>
          ) : isPlenty ? (
            <>
              Thank you! Keep an eye out from Oura for next steps.
            </>
          ) : (
            "Thank you!"
          )}
        </p>
        ) }
        
        {!isConcentrix && !isWiz && (
        <Button
          style={{backgroundColor: campaign.buttonColor || null, color: campaign.buttonTextColor || null, border: (campaign.buttonStrokeColor && `2px solid ${campaign.buttonStrokeColor}`) || null}}
          className="mb-4"
          onClick={() => {
            next();
          }}
        >
          Back to Home
        </Button>
        )}

        {isWiz && (
          <WizButton
            style={{opacity: 0}}
            onClick={() => {
              next();
            }}
          >
            Back to Home
          </WizButton>
        )}
      </Container>
      {isPlenty && (
        <img
          src={PlentyBricks}
          alt="Plenty decoration"
          style={{
            position: "absolute",
            bottom: "-15px",
            right: "-15px",
            width: "420px",
            height: "auto",
            pointerEvents: "none"
          }}
        />
      )}
    </div>
  );
};

export default Complete;
